import { axios } from '@/lib/axios';

export const getLoyaltyPoints = async (id: number): Promise<any[]> => {
    const { data } = await axios.get(`v1/get-user-loyalty-points/${id}`);
    return data;
};
